let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3kBPc")).then(() => parcelRequire('5X6Mk'));